import { put, takeLatest } from 'redux-saga/effects';
import { ManageStateLicense } from '../../reducers/r_index';
import { MessageType, Message } from '../../utils/variables';

import authService from './../../components/api-authorization/AuthorizeService';

// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { pk, codiceUtente } }) {
    try {
        const token = yield authService.getAccessToken();

        const response = yield fetch('/Licenses/BlockLicense/' + pk + '/' + codiceUtente, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const responseResult = yield response.text();


        if (responseResult === Message.Blocked) {
            yield put(ManageStateLicense.creators.blockLicenseSuccess({ isBlocked: responseResult }));
        }
        else if (responseResult === Message.NotBlocked) {
            yield put(ManageStateLicense.creators.blockLicenseFailed("Impossibile bloccare la licenza selezionata."));
        }
        else if (responseResult.substring(0, 5) === MessageType.Error) {
            //se il messaggio è un errore, rimuovo [ERR] all'inizio
            yield put(ManageStateLicense.creators.blockLicenseFailed(responseResult.substring(5)));
        }
        else yield put(ManageStateLicense.creators.blockLicenseFailed(responseResult));

    } catch (e) {
        yield put(ManageStateLicense.creators.blockLicenseFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(ManageStateLicense.types.BLOCK_LICENSE_REQUEST, runAction);
}